export type NrSortDirection = 'asc' | 'desc' | '';
export const rotate: { [key: string]: NrSortDirection } = {asc: 'desc', desc: 'asc', '': 'asc'};
